import { ControlButton } from "reactflow";
import isEmpty from "lodash/isEmpty";
import classNames from "classnames";
import {
  copyIcon,
  deleteIcon,
  errorIcon,
  greenCheckIcon,
  hidePasswordIcon,
  pasteIcon,
  redoIcon,
  showPasswordIcon,
  undoIcon,
} from "../../../assets/icons";

const ReactFlowToolbar = ({
  undo,
  redo,
  canUndo,
  canRedo,
  isFlowValidated,
  handleCopyNodes,
  handlePasteNodes,
  copiedFlow,
  handleCustomRemoveNodes,
  isViewOnlyMode,
  handleViewOnlyMode,
  displayViewOnlyMessage,
}) => (
  <>
    <ControlButton
      onClick={() => handleViewOnlyMode()}
      title="undo"
      className={classNames({ "!border-2 border-black": isViewOnlyMode })}
    >
      <img
        alt="view only"
        src={isViewOnlyMode ? hidePasswordIcon : showPasswordIcon}
      />
    </ControlButton>
    <ControlButton
      onClick={() =>
        isViewOnlyMode ? displayViewOnlyMessage() : canUndo && undo()
      }
      title="undo"
      className={classNames({
        "!cursor-not-allowed ": !canUndo,
      })}
    >
      <img
        alt="undo"
        className={classNames({
          "opacity-10": !canUndo,
        })}
        src={undoIcon}
      />
    </ControlButton>
    <ControlButton
      onClick={() =>
        isViewOnlyMode ? displayViewOnlyMessage() : canRedo && redo()
      }
      title="redo"
      className={classNames({
        "!cursor-not-allowed": !canRedo,
      })}
    >
      <img
        alt="redo"
        className={classNames({
          "opacity-10": !canRedo,
        })}
        src={redoIcon}
      />
    </ControlButton>
    <ControlButton onClick={handleCustomRemoveNodes} title="Delete">
      <img alt="delete" className="invert" src={deleteIcon} />
    </ControlButton>
    <ControlButton
      onClick={handleCopyNodes}
      title="Copy (Hold Shift to drag and select)"
    >
      <img alt="copy" src={copyIcon} />
    </ControlButton>
    <ControlButton
      onClick={() => !isEmpty(copiedFlow.nodes) && handlePasteNodes()}
      title={`Paste ${copiedFlow.nodes.length} nodes & ${copiedFlow.edges.length} edges`}
      className={classNames({
        "!cursor-not-allowed": isEmpty(copiedFlow.nodes),
      })}
    >
      <img
        alt="paste"
        className={classNames({
          "opacity-10": isEmpty(copiedFlow.nodes),
        })}
        src={pasteIcon}
      />
    </ControlButton>
    <ControlButton
      title={
        isFlowValidated
          ? "valid"
          : "The default handles of some nodes are disconnected, or the data is not valid."
      }
    >
      <img alt="valid" src={isFlowValidated ? greenCheckIcon : errorIcon} />
    </ControlButton>
  </>
);

export default ReactFlowToolbar;
